import { render, staticRenderFns } from "./UnreadMarker.vue?vue&type=template&id=4de80ced&scoped=true"
import script from "./UnreadMarker.vue?vue&type=script&lang=js"
export * from "./UnreadMarker.vue?vue&type=script&lang=js"
import style0 from "./UnreadMarker.vue?vue&type=style&index=0&id=4de80ced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de80ced",
  null
  
)

export default component.exports